// Onsite status values mapped to Pill tones.

export const onsiteStatusTone = {
  REQUESTED: 'neutral',
  SCHEDULED: 'warn',
  COMPLETED: 'ok',
  CANCELED: 'bad',
}
